import { MODEL_NAMES } from '../constants/index';
import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingContact extends MessagingBase {
  @service store;

  async fetchContact(externalId) {
    const contact = this.#checkForExistingRecord(MODEL_NAMES.CONTACT, 'externalId', externalId);

    if (contact) {
      return contact;
    }

    const contacts = await this.store.query(MODEL_NAMES.CONTACT, {
      filter: { 'external_ids': externalId },
      include: 'couple',
      page: { number: 1, size: 1 },
    });

    return contacts.get('firstObject') || null;
  }

  #checkForExistingRecord(modelName, key, value) {
    return this.store.peekAll(modelName).find(record => record[key] === value);
  }
}
